export function NaviPulseMark({ className = 'h-9 w-9' }: { className?: string }) {
    return (
        <div
            className={`grid place-items-center rounded-xl border border-line bg-surface-raised text-brand shadow-sm ${className}`}
            aria-hidden
        >
            <svg viewBox="0 0 36 36" className="h-7 w-7" role="img">
                <path
                    d="M8 24.5 14.5 9 20.5 27 28 11.5"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3.2"
                />
                <circle cx="28" cy="11.5" r="3.4" className="fill-accent stroke-surface" strokeWidth="1.6" />
                <path
                    d="M9 28.5c5.2 3.1 12.7 3.1 18 0"
                    fill="none"
                    className="stroke-muted"
                    strokeLinecap="round"
                    strokeWidth="2"
                />
            </svg>
        </div>
    );
}
